import { jwtDecode } from 'jwt-decode';
import { getNonce } from 'shared/services/local-storage';

type GoogleIdTokenClaims = {
  nonce?: string;
};

// GoogleAuthProvider.credential takes no rawNonce, so nothing verifies the return leg but this.
export const hasMatchingSignInNonce = (idToken: string): boolean => {
  const expected = getNonce()?.hashed;

  if (!expected) {
    return false;
  }

  try {
    return jwtDecode<GoogleIdTokenClaims>(idToken).nonce === expected;
  } catch {
    return false;
  }
};
